import React, { useRef, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import TitleDiv from './titleDiv.jsx';
import ImageGrid from './ImageGrid';
import Banners from './Banners';
import '../slider.css';

const SlidePage1 = ({ openPanel, mediaData }) => {
  const [currentMedia, setCurrentMedia] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  const intervalRef = useRef();
  const videoRef = useRef();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [isMuted, setIsMuted] = useState(true);
  const toggleMute = () => setIsMuted(!isMuted);

  useEffect(() => {
    if (mediaData.length > 0) {
      showMedia(0);
    }
  }, [mediaData]);

  const showMedia = (idx) => {
    if (idx >= mediaData.length) return;
    setCurrentMedia(idx);
    setProgress(0);
    clearInterval(intervalRef.current);
    if (mediaData[idx].type === "video") {
      const nextInterval = mediaData[idx].interval * 1000;
      intervalRef.current = setInterval(() => {
        showMedia((idx + 1) % mediaData.length);
      }, nextInterval);
    }
  };

  const handleVideoProgress = (event) => {
    // const video = videoRef.current;
    // if (video && video.duration > 0 && video.buffered.length > 0) {
    //   const bufferedEnd = video.buffered.end(video.buffered.length - 1);
    //   const percent = (bufferedEnd / video.duration) * 100;
    //   setProgress(percent);
    // }
  };

  const handleVideoLoad = () => {
    setIsLoading(false);
    setProgress(100);
  };

  const rootStyle = {
    height: '100%',
    width: '100vw',
    overflow: 'hidden',
    position: 'relative',
  };

  const fullscreenMediaStyle = {
    height: '100%',
    width: '100vw',
    objectFit: 'cover',
    position: 'absolute',
    transition: 'opacity 0.9s ease-in-out',
    opacity: 0,
    left: 0,
    top: 0,
  };

  const loadingStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10001,
    textAlign: 'center',
  };

  const progressBarStyle = {
    width: '200px',
    height: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '2px',
    marginTop: '10px',
  };

  const progressStyle = {
    width: `${progress}%`,
    height: '100%',
    backgroundColor: 'white',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
  };

  const isCurrentMediaVideo = mediaData[currentMedia]?.type === 'video';
  
  
  return (    
    <div style={rootStyle}>
      <div style={{ position: 'relative', height: '100%', width: '100%' }}>
        {mediaData.slice(currentMedia, currentMedia + 2).some((item) => item.type === 'image') ? (
          <ImageGrid images={mediaData.slice(currentMedia, currentMedia + 2)} startIndex={currentMedia} openPanel={openPanel} />
        ) : (
          mediaData.map(
            (item, index) =>
              item.type === 'video' && index === currentMedia && (
                <div
                  key={item.src}
                  style={{
                    ...fullscreenMediaStyle,
                    opacity: index === currentMedia ? 1 : 0,
                    position: 'relative',
                  }}
                >
                  {isLoading && (
                    <div style={loadingStyle}>
                      <div style={{color: 'white', marginBottom: '10px'}}>
                        로딩 상태: {progress.toFixed(1)}%
                      </div>
                      <div style={progressBarStyle}>
                        <div style={progressStyle}></div>
                      </div>
                    </div>
                  )}

                  <video
                    ref={videoRef}
                    key={item.src}
                    loop
                    autoPlay
                    muted={isMuted}
                    playsInline
                    onProgress={handleVideoProgress}
                    onCanPlayThrough={handleVideoLoad}
                    onLoadedData={handleVideoLoad}
                    style={{
                      transform: windowWidth < 1024 ? 'scale(1.18)' : 'none', 
                      height: '100%',
                      zIndex: 10000,
                      width: '100%',
                      objectFit: 'cover',
                      left: 0,
                      top: 0,
                    }}
                  >
                     <source src={item.src} type="video/mp4"></source>
                  </video>
    
                  {index === currentMedia && (
                    <button
                      onClick={toggleMute}
                      style={{
                        zIndex: 10000,
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        background: 'rgba(0,0,0,0.4)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <FontAwesomeIcon color="white" icon={isMuted ? faVolumeMute : faVolumeUp} />
                    </button>
                  )}
                  <TitleDiv title={item.title} desc={item.desc} />
                </div>
              )
          )
        )}
      </div>
      <div style={{ position: 'relative', height: '100%', width: '100%' }}>
        {isCurrentMediaVideo && <Banners />}
        <div className="bottom-address">
          <div style={{ textAlign: 'right' }}>
            (재)시안 이사장 이상훈 사업자등록번호 126-82-00201 경기도 광주시 오포안로17
          </div>
          <div style={{ textAlign: 'right' }}>
            Copyright Ⓒ SIAN FAMILY MEMORIAL PARK, ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlidePage1;
